export default __webpack_public_path__ + "61b70f0c27c32ca9f47d7062f25d669b.svg";